/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarPublic,
  PublicHangarEmbedParams,
  PublicHangarParams,
  SchemaValidationErrorResponse,
  StandardError,
  VehiclePublic
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Public Hangar embed
 */
export const publicHangarEmbed = (
    params: MaybeRefOrGetter<PublicHangarEmbedParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<VehiclePublic[]>(
      {url: `/public/hangars/embed`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicHangarEmbedQueryKey = (params?: MaybeRefOrGetter<PublicHangarEmbedParams>,) => {
    return [
    'public','hangars','embed', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicHangarEmbedQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarEmbed>>, TError = ErrorType<SchemaValidationErrorResponse>>(params: MaybeRefOrGetter<PublicHangarEmbedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarEmbed>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarEmbedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarEmbed>>> = ({ signal }) => publicHangarEmbed(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarEmbed>>, TError, TData>
}

export type PublicHangarEmbedQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarEmbed>>>
export type PublicHangarEmbedQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Public Hangar embed
 */

export function usePublicHangarEmbed<TData = Awaited<ReturnType<typeof publicHangarEmbed>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params: MaybeRefOrGetter<PublicHangarEmbedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarEmbed>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarEmbedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Hangar
 */
export const publicHangar = (
    username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarParams>,
 signal?: AbortSignal
) => {
      username = toValue(username);
params = toValue(params);

      return axiosClient<HangarPublic>(
      {url: `/public/hangars/${username}`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicHangarQueryKey = (username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarParams>,) => {
    return [
    'public','hangars',username, ...(params ? [params] : [])
    ] as const;
    }


export const getPublicHangarQueryOptions = <TData = Awaited<ReturnType<typeof publicHangar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangar>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarQueryKey(username,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangar>>> = ({ signal }) => publicHangar(username,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangar>>, TError, TData>
}

export type PublicHangarQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangar>>>
export type PublicHangarQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Hangar
 */

export function usePublicHangar<TData = Awaited<ReturnType<typeof publicHangar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangar>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarQueryOptions(username,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






